import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { Injector } from '@angular/core';
import { IAgreementUserLog } from '@fi-app/agreement/agreement';

export class AgreementUserLogModel {
    Id: number;
    AgreementId: number;
    ContentLanguageId: number;
    AgreementVersion: any;
    UserEmailAddress: string;
    UserIPAddress: string;
    UserPhoneNumber: string;
    AcceptedByUserId: number;
    AcceptedByUserName: string;
    AcceptedOn: any;
    AcceptedOnDate: any;
    ContentLanguageName: string;

    constructor(data: IAgreementUserLog, injector: Injector) {
        data = data || {};

        this.Id = data.Id;
        this.AgreementId = data.AgreementId;
        this.ContentLanguageId = data.ContentLanguageId;
        this.AgreementVersion = data.AgreementVersion;
        this.UserEmailAddress = data.UserEmailAddress;
        this.UserIPAddress = data.UserIPAddress;
        this.UserPhoneNumber = data.UserPhoneNumber;
        this.AcceptedByUserId = data.AcceptedByUserId;
        this.AcceptedByUserName = data.AcceptedByUserName;
        this.AcceptedOn = data.AcceptedOn;
        this.AcceptedOnDate = data.AcceptedOnDate;
        const customerDataService = injector.get(FiCustomerDataService);
        const lang = customerDataService.customerData.ContentLanguages.find(
            (item) => item.Id === data.ContentLanguageId,
        );
        if (lang) this.ContentLanguageName = lang.Name;
    }
}
